import React, { Children } from 'react';
import { Link } from 'react-router-dom';
import { Footer } from '../components/Footer';
import { Navigation } from '../components/Navigation';
export function PrivacyPage() {
  return <div className="min-h-screen w-full bg-white" data-id="element-2430">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-white/90 backdrop-blur-md border-b border-gray-100" data-id="element-2431">
        <div className="w-full px-6 md:px-12 lg:px-24" data-id="element-2432">
          <div className="max-w-7xl mx-auto h-20 flex items-center" data-id="element-2433">
            <Link to="/" data-id="element-2434">
              <img src="https://cdn.magicpatterns.com/uploads/9qJGNjQNSV94689CCZT1kr/newTM_black_copy.png" alt="Synthia" className="h-8" data-id="element-2435" />
            </Link>
            <Navigation data-id="element-2436" />
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="pt-32 pb-24 px-6 md:px-12 lg:px-24" data-id="element-2437">
        <div className="max-w-4xl mx-auto" data-id="element-2438">
          <h1 className="text-5xl md:text-6xl font-bold mb-16 font-['Syne'] text-black" data-id="element-2439">
            PRIVACY POLICY
          </h1>

          <div className="space-y-12 font-['Lora'] text-gray-800 leading-relaxed" data-id="element-2440">
            <section data-id="element-2441">
              <h2 className="text-3xl font-bold mb-4 font-['Syne'] text-black" data-id="element-2442">
                1. Overview
              </h2>
              <p className="text-lg" data-id="element-2443">
                MeetSynthia, Inc. ("Synthia," "we," "us," or "our") is committed
                to protecting your privacy. This Privacy Policy explains how we
                collect, use, store, and protect information related to your use
                of our website and Platform (collectively, the "Services").
              </p>
              <p className="text-lg mt-4" data-id="element-2444">
                This Policy applies to all users of MeetSynthia.ai, including
                enterprise clients, individual users, and visitors to our
                website.
              </p>
            </section>

            <section data-id="element-2445">
              <h2 className="text-3xl font-bold mb-4 font-['Syne'] text-black" data-id="element-2446">
                2. Information We Collect
              </h2>
              <p className="text-lg mb-4" data-id="element-2447">
                We collect the following categories of information:
              </p>

              <h3 className="text-2xl font-bold mb-3 font-['Syne'] text-black" data-id="element-2448">
                Account Data
              </h3>
              <ul className="list-disc pl-6 space-y-2 text-lg" data-id="element-2449">
                <li data-id="element-2450">Name, email address, organization name, job title/role</li>
                <li data-id="element-2451">Login credentials (securely hashed and encrypted)</li>
                <li data-id="element-2452">
                  Billing and payment information (processed through third-party
                  payment processors)
                </li>
              </ul>

              <h3 className="text-2xl font-bold mb-3 mt-6 font-['Syne'] text-black" data-id="element-2453">
                Usage Data
              </h3>
              <ul className="list-disc pl-6 space-y-2 text-lg" data-id="element-2454">
                <li data-id="element-2455">System logs, error reports, and performance telemetry</li>
                <li data-id="element-2456">
                  Workflow interactions, guardrail configurations, and usage
                  patterns
                </li>
                <li data-id="element-2457">Feature adoption and engagement metrics</li>
                <li data-id="element-2458">
                  Browser type, IP address, device information, and access times
                </li>
              </ul>

              <h3 className="text-2xl font-bold mb-3 mt-6 font-['Syne'] text-black" data-id="element-2459">
                Prompt Metadata and Configurations
              </h3>
              <ul className="list-disc pl-6 space-y-2 text-lg" data-id="element-2460">
                <li data-id="element-2461">
                  Text inputs and prompt structures necessary for guardrail
                  operations
                </li>
                <li data-id="element-2462">
                  Custom guardrails, roles, attributes, and workflow
                  configurations
                </li>
                <li data-id="element-2463">
                  Institutional knowledge and domain-specific rules you create
                </li>
                <li data-id="element-2464">
                  Audit logs of prompt transformations and governance actions
                </li>
              </ul>

              <h3 className="text-2xl font-bold mb-3 mt-6 font-['Syne'] text-black" data-id="element-2465">
                Cookies and Analytics
              </h3>
              <ul className="list-disc pl-6 space-y-2 text-lg" data-id="element-2466">
                <li data-id="element-2467">
                  Non-identifiable technical information to improve service
                  performance
                </li>
                <li data-id="element-2468">Session management and authentication tokens</li>
                <li data-id="element-2469">
                  Analytics data to understand usage patterns and optimize
                  features
                </li>
              </ul>

              <h3 className="text-2xl font-bold mb-3 mt-6 font-['Syne'] text-black" data-id="element-2470">
                We do NOT collect:
              </h3>
              <ul className="list-disc pl-6 space-y-2 text-lg" data-id="element-2471">
                <li data-id="element-2472">
                  Content of final AI outputs (these remain with you and the AI
                  provider)
                </li>
                <li data-id="element-2473">
                  Sensitive personal information unless specifically required
                  for service delivery
                </li>
                <li data-id="element-2474">Data from your interactions with third-party AI models</li>
              </ul>

              <h3 className="text-2xl font-bold mb-3 mt-6 font-['Syne'] text-black" data-id="element-2475">
                We do NOT use your data to:
              </h3>
              <ul className="list-disc pl-6 space-y-2 text-lg" data-id="element-2476">
                <li data-id="element-2477">Train third-party AI models</li>
                <li data-id="element-2478">Build external datasets or benchmark corpora</li>
                <li data-id="element-2479">Market to other customers</li>
                <li data-id="element-2480">Develop competing products or services</li>
              </ul>
            </section>

            <section data-id="element-2481">
              <h2 className="text-3xl font-bold mb-4 font-['Syne'] text-black" data-id="element-2482">
                3. How We Use Information
              </h2>
              <p className="text-lg mb-4" data-id="element-2483">We use collected information to:</p>

              <h3 className="text-2xl font-bold mb-3 font-['Syne'] text-black" data-id="element-2484">
                Service Delivery
              </h3>
              <ul className="list-disc pl-6 space-y-2 text-lg" data-id="element-2485">
                <li data-id="element-2486">Provide, operate, and maintain the Platform</li>
                <li data-id="element-2487">
                  Process and optimize prompt instructions through our
                  instruction layer
                </li>
                <li data-id="element-2488">
                  Apply guardrails, governance rules, and compliance controls
                </li>
                <li data-id="element-2489">Enable integrations with your chosen AI providers</li>
              </ul>

              <h3 className="text-2xl font-bold mb-3 mt-6 font-['Syne'] text-black" data-id="element-2490">
                Service Improvement
              </h3>
              <ul className="list-disc pl-6 space-y-2 text-lg" data-id="element-2491">
                <li data-id="element-2492">
                  Analyze usage patterns to improve product features and
                  performance
                </li>
                <li data-id="element-2493">Identify and resolve technical issues</li>
                <li data-id="element-2494">Develop new capabilities and governance frameworks</li>
                <li data-id="element-2495">Optimize guardrail effectiveness and response times</li>
              </ul>

              <h3 className="text-2xl font-bold mb-3 mt-6 font-['Syne'] text-black" data-id="element-2496">
                Compliance and Security
              </h3>
              <ul className="list-disc pl-6 space-y-2 text-lg" data-id="element-2497">
                <li data-id="element-2498">Maintain audit logs for compliance and debugging</li>
                <li data-id="element-2499">Detect and prevent fraud, abuse, or security threats</li>
                <li data-id="element-2500">
                  Comply with legal obligations and regulatory requirements
                </li>
                <li data-id="element-2501">Enforce our Terms and Conditions</li>
              </ul>

              <h3 className="text-2xl font-bold mb-3 mt-6 font-['Syne'] text-black" data-id="element-2502">
                Communication
              </h3>
              <ul className="list-disc pl-6 space-y-2 text-lg" data-id="element-2503">
                <li data-id="element-2504">
                  Send service updates, security alerts, and product
                  announcements
                </li>
                <li data-id="element-2505">Respond to support requests and customer inquiries</li>
                <li data-id="element-2506">
                  Provide training, documentation, and onboarding assistance
                </li>
                <li data-id="element-2507">
                  Send marketing communications (with your consent, and with
                  opt-out options)
                </li>
              </ul>

              <h3 className="text-2xl font-bold mb-3 mt-6 font-['Syne'] text-black" data-id="element-2508">
                Research and Development
              </h3>
              <ul className="list-disc pl-6 space-y-2 text-lg" data-id="element-2509">
                <li data-id="element-2510">
                  Develop improved governance patterns and best practices (using
                  anonymized, aggregated data)
                </li>
                <li data-id="element-2511">
                  Create marketplace components based on common industry needs
                </li>
                <li data-id="element-2512">Enhance security, privacy, and compliance capabilities</li>
              </ul>
            </section>

            <section data-id="element-2513">
              <h2 className="text-3xl font-bold mb-4 font-['Syne'] text-black" data-id="element-2514">
                4. Legal Basis for Processing (GDPR)
              </h2>
              <p className="text-lg mb-4" data-id="element-2515">
                For users in the European Economic Area (EEA), United Kingdom,
                or Switzerland, we process personal data based on the following
                legal grounds:
              </p>

              <h3 className="text-2xl font-bold mb-3 font-['Syne'] text-black" data-id="element-2516">
                Contract Necessity
              </h3>
              <p className="text-lg" data-id="element-2517">
                Processing is necessary to provide the Services you requested
                and to fulfill our contractual obligations.
              </p>

              <h3 className="text-2xl font-bold mb-3 mt-6 font-['Syne'] text-black" data-id="element-2518">
                Legitimate Interests
              </h3>
              <p className="text-lg" data-id="element-2519">
                We have legitimate interests in maintaining and improving the
                Platform, ensuring security, preventing fraud, and conducting
                business operations, provided these interests do not override
                your fundamental rights and freedoms.
              </p>

              <h3 className="text-2xl font-bold mb-3 mt-6 font-['Syne'] text-black" data-id="element-2520">
                Consent
              </h3>
              <p className="text-lg" data-id="element-2521">
                For optional features such as marketing communications, beta
                programs, or analytics, we obtain explicit consent which you may
                withdraw at any time.
              </p>

              <h3 className="text-2xl font-bold mb-3 mt-6 font-['Syne'] text-black" data-id="element-2522">
                Legal Obligation
              </h3>
              <p className="text-lg" data-id="element-2523">
                Processing is necessary to comply with applicable laws,
                regulations, court orders, or governmental requests.
              </p>

              <p className="text-lg mt-4" data-id="element-2524">
                You have the right to object to processing based on legitimate
                interests. Contact us at privacy@meetsynthia.ai to exercise this
                right.
              </p>
            </section>

            <section data-id="element-2525">
              <h2 className="text-3xl font-bold mb-4 font-['Syne'] text-black" data-id="element-2526">
                5. Data Hosting and Retention
              </h2>

              <h3 className="text-2xl font-bold mb-3 font-['Syne'] text-black" data-id="element-2527">
                Data Storage Locations
              </h3>
              <p className="text-lg mb-4" data-id="element-2528">
                Depending on your deployment model, data may be stored:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-lg" data-id="element-2529">
                <li data-id="element-2530">
                  In your own infrastructure (self-hosted or VPC deployment) –
                  you maintain full control and custody
                </li>
                <li data-id="element-2531">
                  In Synthia's secure cloud environment (AWS or equivalent) –
                  encrypted in transit and at rest
                </li>
                <li data-id="element-2532">
                  In hybrid configurations as specified in your service
                  agreement
                </li>
              </ul>
              <p className="text-lg mt-4" data-id="element-2533">
                All cloud-hosted data is encrypted using industry-standard
                protocols (AES-256 for data at rest, TLS 1.3 for data in
                transit).
              </p>

              <h3 className="text-2xl font-bold mb-3 mt-6 font-['Syne'] text-black" data-id="element-2534">
                Data Retention Periods
              </h3>
              <p className="text-lg mb-4" data-id="element-2535">
                We retain data only as long as necessary to provide Services and
                comply with legal obligations:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-lg" data-id="element-2536">
                <li data-id="element-2537">
                  Active account data: Retained while your account is active
                </li>
                <li data-id="element-2538">
                  Audit logs and metadata: Retained for 90 days after account
                  termination for debugging and compliance purposes
                </li>
                <li data-id="element-2539">
                  Billing records: Retained for 7 years to comply with financial
                  regulations
                </li>
                <li data-id="element-2540">
                  Anonymized analytics: May be retained indefinitely in
                  aggregated form
                </li>
              </ul>

              <p className="text-lg mt-4 mb-2" data-id="element-2541">
                Upon account termination, we will:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-lg" data-id="element-2542">
                <li data-id="element-2543">
                  Securely delete or return all customer data within 30 days
                </li>
                <li data-id="element-2544">
                  Permanently remove all personally identifiable information
                  from our systems
                </li>
                <li data-id="element-2545">
                  Retain only minimal anonymized data required for legal
                  compliance
                </li>
              </ul>
            </section>

            <section data-id="element-2546">
              <h2 className="text-3xl font-bold mb-4 font-['Syne'] text-black" data-id="element-2547">
                6. Data Sharing and Disclosure
              </h2>
              <p className="text-lg mb-4" data-id="element-2548">
                We do NOT sell, rent, or trade your personal information or
                proprietary data.
              </p>
              <p className="text-lg mb-4" data-id="element-2549">
                We may share limited information only in the following
                circumstances:
              </p>

              <h3 className="text-2xl font-bold mb-3 font-['Syne'] text-black" data-id="element-2550">
                With Service Providers
              </h3>
              <ul className="list-disc pl-6 space-y-2 text-lg" data-id="element-2551">
                <li data-id="element-2552">Cloud hosting providers (AWS, Google Cloud Platform)</li>
                <li data-id="element-2553">Payment processors (Stripe, PayPal)</li>
                <li data-id="element-2554">
                  Analytics and monitoring tools (with data anonymization)
                </li>
                <li data-id="element-2555">Customer support platforms</li>
              </ul>
              <p className="text-lg mt-4" data-id="element-2556">
                All service providers are bound by strict confidentiality
                agreements and process data only as instructed.
              </p>

              <h3 className="text-2xl font-bold mb-3 mt-6 font-['Syne'] text-black" data-id="element-2557">
                For Legal Compliance
              </h3>
              <ul className="list-disc pl-6 space-y-2 text-lg" data-id="element-2558">
                <li data-id="element-2559">
                  In response to valid legal process (subpoenas, court orders,
                  warrants)
                </li>
                <li data-id="element-2560">To comply with applicable laws and regulations</li>
                <li data-id="element-2561">
                  To protect the rights, property, or safety of MeetSynthia, our
                  users, or the public
                </li>
                <li data-id="element-2562">To enforce our Terms and Conditions</li>
              </ul>

              <h3 className="text-2xl font-bold mb-3 mt-6 font-['Syne'] text-black" data-id="element-2563">
                In Business Transfers
              </h3>
              <p className="text-lg" data-id="element-2564">
                In the event of a merger, acquisition, or sale of assets, your
                information may be transferred to the acquiring entity, subject
                to the same privacy protections
              </p>

              <h3 className="text-2xl font-bold mb-3 mt-6 font-['Syne'] text-black" data-id="element-2565">
                With Your Consent
              </h3>
              <ul className="list-disc pl-6 space-y-2 text-lg" data-id="element-2566">
                <li data-id="element-2567">
                  When you explicitly authorize us to share information with
                  third parties
                </li>
                <li data-id="element-2568">For specific integrations or partnerships you enable</li>
              </ul>

              <h3 className="text-2xl font-bold mb-3 mt-6 font-['Syne'] text-black" data-id="element-2569">
                Protection of Proprietary Information
              </h3>
              <p className="text-lg mb-4" data-id="element-2570">
                We implement strict safeguards to protect your proprietary and
                confidential information:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-lg" data-id="element-2571">
                <li data-id="element-2572">
                  Client-specific guardrails, workflows, and institutional
                  knowledge are never shared with other customers
                </li>
                <li data-id="element-2573">
                  Custom configurations and domain expertise remain confidential
                </li>
                <li data-id="element-2574">
                  Access to client data is restricted to authorized personnel on
                  a need-to-know basis
                </li>
                <li data-id="element-2575">
                  All employees and contractors sign confidentiality agreements
                </li>
              </ul>
              <p className="text-lg mt-4" data-id="element-2576">
                While your proprietary information remains confidential, we may
                develop similar or related governance patterns for other clients
                based on:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-lg" data-id="element-2577">
                <li data-id="element-2578">Industry best practices and public knowledge</li>
                <li data-id="element-2579">Independent development and research</li>
                <li data-id="element-2580">
                  Common use cases that naturally overlap across organizations
                </li>
              </ul>
              <p className="text-lg mt-4" data-id="element-2581">
                Any marketplace components derived from client work are
                sufficiently abstracted and generalized to remove all
                client-specific proprietary information, trade secrets, and
                confidential business logic.
              </p>
            </section>

            <section data-id="element-2582">
              <h2 className="text-3xl font-bold mb-4 font-['Syne'] text-black" data-id="element-2583">
                7. International Data Transfers
              </h2>
              <p className="text-lg mb-4" data-id="element-2584">
                If you are located outside the United States, your information
                may be transferred to and processed in the United States or
                other countries where our service providers operate.
              </p>
              <p className="text-lg mb-4" data-id="element-2585">
                For transfers from the EEA, UK, or Switzerland, we use approved
                safeguards including:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-lg" data-id="element-2586">
                <li data-id="element-2587">
                  Standard Contractual Clauses (SCCs) approved by the European
                  Commission
                </li>
                <li data-id="element-2588">
                  Data Processing Agreements (DPAs) with explicit privacy
                  commitments
                </li>
                <li data-id="element-2589">Adequate security measures and encryption protocols</li>
              </ul>
              <p className="text-lg mt-4" data-id="element-2590">
                We ensure that all international transfers comply with GDPR, UK
                GDPR, and other applicable data protection laws.
              </p>
            </section>

            <section data-id="element-2591">
              <h2 className="text-3xl font-bold mb-4 font-['Syne'] text-black" data-id="element-2592">
                8. Your Privacy Rights
              </h2>
              <p className="text-lg mb-4" data-id="element-2593">
                Under GDPR, CCPA, and similar laws, you have the following
                rights:
              </p>

              <h3 className="text-2xl font-bold mb-3 font-['Syne'] text-black" data-id="element-2594">
                Right to Access
              </h3>
              <ul className="list-disc pl-6 space-y-2 text-lg" data-id="element-2595">
                <li data-id="element-2596">
                  Request a copy of the personal information we hold about you
                </li>
                <li data-id="element-2597">Receive information about how we process your data</li>
              </ul>

              <h3 className="text-2xl font-bold mb-3 mt-6 font-['Syne'] text-black" data-id="element-2598">
                Right to Rectification
              </h3>
              <p className="text-lg" data-id="element-2599">
                Correct inaccurate or incomplete personal information
              </p>

              <h3 className="text-2xl font-bold mb-3 mt-6 font-['Syne'] text-black" data-id="element-2600">
                Right to Erasure ("Right to Be Forgotten")
              </h3>
              <p className="text-lg" data-id="element-2601">
                Request deletion of your personal information (subject to legal
                retention requirements)
              </p>

              <h3 className="text-2xl font-bold mb-3 mt-6 font-['Syne'] text-black" data-id="element-2602">
                Right to Restriction
              </h3>
              <p className="text-lg" data-id="element-2603">
                Request that we limit the processing of your personal
                information in certain circumstances
              </p>

              <h3 className="text-2xl font-bold mb-3 mt-6 font-['Syne'] text-black" data-id="element-2604">
                Right to Data Portability
              </h3>
              <ul className="list-disc pl-6 space-y-2 text-lg" data-id="element-2605">
                <li data-id="element-2606">
                  Receive your personal information in a structured,
                  machine-readable format
                </li>
                <li data-id="element-2607">
                  Request transfer of your data to another service provider
                </li>
              </ul>

              <h3 className="text-2xl font-bold mb-3 mt-6 font-['Syne'] text-black" data-id="element-2608">
                Right to Object
              </h3>
              <p className="text-lg" data-id="element-2609">
                Object to processing based on legitimate interests or for direct
                marketing purposes
              </p>

              <h3 className="text-2xl font-bold mb-3 mt-6 font-['Syne'] text-black" data-id="element-2610">
                Right to Opt-Out (CCPA)
              </h3>
              <p className="text-lg" data-id="element-2611">
                Opt-out of the "sale" of personal information (note: we do not
                sell personal information)
              </p>

              <h3 className="text-2xl font-bold mb-3 mt-6 font-['Syne'] text-black" data-id="element-2612">
                Right to Non-Discrimination
              </h3>
              <p className="text-lg" data-id="element-2613">
                Exercise your privacy rights without receiving discriminatory
                treatment
              </p>

              <p className="text-lg mt-6" data-id="element-2614">
                To exercise any of these rights, contact us at: 📧
                privacy@meetsynthia.ai
              </p>
              <p className="text-lg mt-4" data-id="element-2615">
                We will respond to your request within 30 days (or as required
                by applicable law). We may require verification of your identity
                before processing requests.
              </p>
            </section>

            <section data-id="element-2616">
              <h2 className="text-3xl font-bold mb-4 font-['Syne'] text-black" data-id="element-2617">
                9. Enterprise Data Control
              </h2>
              <p className="text-lg mb-4" data-id="element-2618">
                For enterprise clients operating under a Data Processing
                Agreement (DPA):
              </p>

              <h3 className="text-2xl font-bold mb-3 font-['Syne'] text-black" data-id="element-2619">
                Data Controller vs. Data Processor
              </h3>
              <ul className="list-disc pl-6 space-y-2 text-lg" data-id="element-2620">
                <li data-id="element-2621">
                  The enterprise client is the data controller responsible for
                  determining purposes and means of processing
                </li>
                <li data-id="element-2622">
                  Synthia acts as a data processor, processing data solely
                  according to written instructions
                </li>
              </ul>

              <h3 className="text-2xl font-bold mb-3 mt-6 font-['Syne'] text-black" data-id="element-2623">
                Client Responsibilities
              </h3>
              <ul className="list-disc pl-6 space-y-2 text-lg" data-id="element-2624">
                <li data-id="element-2625">Ensuring lawful basis for data processing</li>
                <li data-id="element-2626">Obtaining necessary consents from end users</li>
                <li data-id="element-2627">Complying with applicable data protection laws</li>
                <li data-id="element-2628">Providing privacy notices to affected individuals</li>
              </ul>

              <h3 className="text-2xl font-bold mb-3 mt-6 font-['Syne'] text-black" data-id="element-2629">
                Synthia's Commitments
              </h3>
              <ul className="list-disc pl-6 space-y-2 text-lg" data-id="element-2630">
                <li data-id="element-2631">Process data only as instructed by the client</li>
                <li data-id="element-2632">
                  Implement appropriate technical and organizational security
                  measures
                </li>
                <li data-id="element-2633">
                  Assist with data subject requests (access, deletion,
                  portability)
                </li>
                <li data-id="element-2634">Notify clients of any data breaches within 72 hours</li>
                <li data-id="element-2635">Delete or return all client data upon termination</li>
              </ul>

              <h3 className="text-2xl font-bold mb-3 mt-6 font-['Syne'] text-black" data-id="element-2636">
                Subprocessors
              </h3>
              <ul className="list-disc pl-6 space-y-2 text-lg" data-id="element-2637">
                <li data-id="element-2638">
                  We maintain a list of approved subprocessors (available upon
                  request)
                </li>
                <li data-id="element-2639">
                  Clients will be notified of any changes to subprocessors with
                  opportunity to object
                </li>
              </ul>
            </section>

            <section data-id="element-2640">
              <h2 className="text-3xl font-bold mb-4 font-['Syne'] text-black" data-id="element-2641">
                10. Security Measures
              </h2>
              <p className="text-lg mb-4" data-id="element-2642">
                We implement comprehensive security controls to protect your
                information:
              </p>

              <h3 className="text-2xl font-bold mb-3 font-['Syne'] text-black" data-id="element-2643">
                Technical Safeguards
              </h3>
              <ul className="list-disc pl-6 space-y-2 text-lg" data-id="element-2644">
                <li data-id="element-2645">
                  Encryption of data in transit (TLS 1.3) and at rest (AES-256)
                </li>
                <li data-id="element-2646">Multi-factor authentication (MFA) for account access</li>
                <li data-id="element-2647">Regular security audits and penetration testing</li>
                <li data-id="element-2648">Automated vulnerability scanning and patch management</li>
                <li data-id="element-2649">
                  Role-based access control (RBAC) with principle of least
                  privilege
                </li>
              </ul>

              <h3 className="text-2xl font-bold mb-3 mt-6 font-['Syne'] text-black" data-id="element-2650">
                Organizational Safeguards
              </h3>
              <ul className="list-disc pl-6 space-y-2 text-lg" data-id="element-2651">
                <li data-id="element-2652">SOC 2 Type II compliance framework</li>
                <li data-id="element-2653">
                  Employee background checks and confidentiality agreements
                </li>
                <li data-id="element-2654">Security awareness training for all personnel</li>
                <li data-id="element-2655">Incident response and breach notification procedures</li>
                <li data-id="element-2656">Regular security policy reviews and updates</li>
              </ul>

              <p className="text-lg mt-4" data-id="element-2657">
                While we implement industry-leading security measures, no online
                service is 100% secure. You acknowledge the inherent risks of
                internet transmission and agree to use strong passwords, enable
                MFA, and follow security best practices.
              </p>
            </section>

            <section data-id="element-2658">
              <h2 className="text-3xl font-bold mb-4 font-['Syne'] text-black" data-id="element-2659">
                11. Children's Privacy
              </h2>
              <p className="text-lg mb-4" data-id="element-2660">
                Our Services are not intended for individuals under the age of
                18. We do not knowingly collect personal information from
                minors.
              </p>
              <p className="text-lg mb-4" data-id="element-2661">
                If we become aware that we have collected information from a
                child under 18, we will take immediate steps to delete such
                information.
              </p>
              <p className="text-lg" data-id="element-2662">
                If you believe we may have inadvertently collected information
                from a minor, contact us at privacy@meetsynthia.ai.
              </p>
            </section>

            <section data-id="element-2663">
              <h2 className="text-3xl font-bold mb-4 font-['Syne'] text-black" data-id="element-2664">
                12. Cookies and Tracking Technologies
              </h2>
              <p className="text-lg mb-4" data-id="element-2665">
                We use cookies and similar technologies to:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-lg" data-id="element-2666">
                <li data-id="element-2667">Maintain user sessions and authentication</li>
                <li data-id="element-2668">Remember user preferences and settings</li>
                <li data-id="element-2669">Analyze usage patterns and improve user experience</li>
                <li data-id="element-2670">Measure marketing campaign effectiveness</li>
              </ul>

              <h3 className="text-2xl font-bold mb-3 mt-6 font-['Syne'] text-black" data-id="element-2671">
                Cookie Categories:
              </h3>

              <p className="text-lg font-bold mt-4" data-id="element-2672">
                Essential Cookies (Required)
              </p>
              <ul className="list-disc pl-6 space-y-2 text-lg" data-id="element-2673">
                <li data-id="element-2674">Necessary for core functionality and security</li>
                <li data-id="element-2675">Cannot be disabled without impairing service</li>
              </ul>

              <p className="text-lg font-bold mt-4" data-id="element-2676">
                Functional Cookies (Optional)
              </p>
              <ul className="list-disc pl-6 space-y-2 text-lg" data-id="element-2677">
                <li data-id="element-2678">Remember your preferences and settings</li>
                <li data-id="element-2679">Enhance user experience</li>
              </ul>

              <p className="text-lg font-bold mt-4" data-id="element-2680">
                Analytics Cookies (Optional)
              </p>
              <ul className="list-disc pl-6 space-y-2 text-lg" data-id="element-2681">
                <li data-id="element-2682">Help us understand how users interact with the Platform</li>
                <li data-id="element-2683">Aggregate and anonymized data only</li>
              </ul>

              <p className="text-lg font-bold mt-4" data-id="element-2684">
                Marketing Cookies (Optional)
              </p>
              <ul className="list-disc pl-6 space-y-2 text-lg" data-id="element-2685">
                <li data-id="element-2686">Track effectiveness of advertising campaigns</li>
                <li data-id="element-2687">Require explicit consent</li>
              </ul>

              <p className="text-lg mt-4" data-id="element-2688">
                You can control cookie preferences through your browser settings
                or our cookie consent manager. Disabling certain cookies may
                limit functionality.
              </p>
            </section>

            <section data-id="element-2689">
              <h2 className="text-3xl font-bold mb-4 font-['Syne'] text-black" data-id="element-2690">
                13. Updates to This Policy
              </h2>
              <p className="text-lg mb-4" data-id="element-2691">
                We may update this Privacy Policy periodically to reflect
                changes in:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-lg" data-id="element-2692">
                <li data-id="element-2693">Our Services and features</li>
                <li data-id="element-2694">Legal or regulatory requirements</li>
                <li data-id="element-2695">Industry best practices and security standards</li>
                <li data-id="element-2696">User feedback and concerns</li>
              </ul>

              <p className="text-lg mt-4 mb-2" data-id="element-2697">
                When we make material changes, we will:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-lg" data-id="element-2698">
                <li data-id="element-2699">Post the updated Policy with a new "Last Updated" date</li>
                <li data-id="element-2700">
                  Notify you via email or prominent notice in the Platform
                </li>
                <li data-id="element-2701">Obtain consent if required by applicable law</li>
              </ul>

              <p className="text-lg mt-4" data-id="element-2702">
                Your continued use of the Services after changes are posted
                constitutes acceptance of the revised Policy. We encourage you
                to review this Policy regularly.
              </p>
            </section>

            <section data-id="element-2703">
              <h2 className="text-3xl font-bold mb-4 font-['Syne'] text-black" data-id="element-2704">
                14. Contact Us
              </h2>
              <p className="text-lg mb-4" data-id="element-2705">
                For questions, concerns, or requests regarding this Privacy
                Policy:
              </p>
              <p className="text-lg" data-id="element-2706">
                📧 privacy@meetsynthia.ai
                <br data-id="element-2707" />
                📧 legal@meetsynthia.ai (for DPA requests)
              </p>
              <p className="text-lg mt-4" data-id="element-2708">
                Mailing Address:
                <br data-id="element-2709" />
                MeetSynthia, Inc.
                <br data-id="element-2710" />
                Wilmington, Delaware, USA
              </p>
              <p className="text-lg mt-4" data-id="element-2711">
                Data Protection Officer (for GDPR inquiries): dpo@meetsynthia.ai
              </p>
              <p className="text-lg mt-4" data-id="element-2712">
                We will respond to inquiries within 30 days (or as required by
                applicable law).
              </p>
            </section>

            <section data-id="element-2713">
              <h2 className="text-3xl font-bold mb-4 font-['Syne'] text-black" data-id="element-2714">
                15. Supervisory Authority
              </h2>
              <p className="text-lg" data-id="element-2715">
                If you are located in the EEA, UK, or Switzerland, you have the
                right to lodge a complaint with your local data protection
                authority if you believe we have violated your privacy rights.
              </p>
            </section>

            <section className="border-t border-gray-200 pt-8" data-id="element-2716">
              <h3 className="text-2xl font-bold mb-4 font-['Syne'] text-black" data-id="element-2717">
                FOOTER DISCLOSURE
              </h3>
              <p className="text-lg mb-4" data-id="element-2718">
                MeetSynthia.ai operates at the instruction layer only—we do not
                generate AI outputs. All answers and content are produced by
                frontier AI models (OpenAI, Anthropic, Google, etc.).
                Enterprises retain full ownership of their data. Your
                proprietary information is never shared with third parties or
                other customers.
              </p>
              <p className="text-lg" data-id="element-2719">
                © 2025 MeetSynthia, Inc. All rights reserved.
              </p>
              <p className="text-lg mt-2" data-id="element-2720">Last Updated: December 26, 2024</p>
            </section>
          </div>
        </div>
      </main>

      <Footer data-id="element-2721" />
    </div>;
}